/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import { AddToCalendarButton } from "add-to-calendar-button-react";
import { confirmAlert } from "react-confirm-alert";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";
import QRCode from "react-qr-code";
import { fetchAssociatedAttendee } from "@mainaction";
import { WEB_PORTAL_URL, SITE_URL, WEB_FOLDER } from "@constant";
import { classNames } from "@utilscommon";
import Loader from "@loader";
import GooglePlay from "../../../assets/image/GooglePlay.png";
import AppStore from "../../../assets/image/AppStore.png";
import brokenCircle from "../../../assets/image/check-circle-broken.svg";
import LocaleStrings from "@language";
import SocialShare from "../../social-promotion/components/social-share";
import AssociateUser from "./associateuser";

const ThankYou = (props) => {
  const { state } = useLocation();
  let { eventSettingsData, eventData, session } = props;
  const alertRef = useRef(null);
  const [displayPasscode, setDisplayPasscode] = useState(false);
  const [associateuser, setassociateuser] = useState([]);
  let hideAssignDetails =
    JSON.parse(eventSettingsData?.data?.custom_settings ?? "{}")
      ?.hide_applinks_qr ?? false;
  // console.log("eventSettingsData :- ", eventSettingsData);
  // console.log("eventData :- ", eventData);
  // console.log("state :- ", state);
  useEffect(() => {
    if ((state?.exhibitorid || state?.sponsorid) && state?.createcompany) {
      let values = {
        eventid: session.eventid,
        exhibitorid: state.exhibitorid,
        sponsorid: state.sponsorid,
      };
      props.fetchAssociatedAttendee(session, values, (response) => {
        if (response.success == 1) {
          setassociateuser(response.data.resource);
        }
      });
    }
  }, []);

  const handleassociateuser = () => {
    let values = {
      eventid: session.eventid,
      exhibitorid: state.exhibitorid,
      sponsorid: state.sponsorid,
    };
    props.fetchAssociatedAttendee(session, values, (response) => {
      if (response.success == 1) {
        setassociateuser(response.data.resource);
      }
    });
  };

  const handleApp = (app) => {
    if (app === "ios") {
      window.open(eventData?.iosappstorelink, "_blank");
    } else {
      window.open(eventData?.androidplaystorelink, "_blank");
    }
  };

  const openWebPortel = () => {
    let eventSeoCode = eventData?.seocode;
    let hostname = window.location.hostname;

    let portal = WEB_PORTAL_URL.replace("{seocode}", eventSeoCode);
    if (!hostname.includes(SITE_URL)) {
      if (eventSeoCode.charAt(eventSeoCode.length - 1) === "/") {
        eventSeoCode = eventSeoCode.slice(0, -1);
      }
      portal = `https://${eventSeoCode}${WEB_FOLDER}`;
    }
    let url = `${portal}/overview`;
    if (
      state?.email &&
      state?.passcode &&
      eventSettingsData?.data?.autologin === true
    ) {
      url = `${portal}/autologin?email=${state?.email}&passcode=${state?.passcode}`;
    }
    window.open(`${url}`, "_blank");
  };

  const closeAlert = () => {
    alertRef.current.className = "hidden";
  };

  const handlePasscodeDisplay = (action) => {
    setDisplayPasscode(action === "display" ? true : false);
  };

  const renderAssociateUser = () => {
    let number = Number(state.noofmember) - 1;
    const result = [...Array(number)].map(
      () => Math.floor(Math.random() * 100) + 1
    );

    let finalarray = associateuser.filter((i) => {
      return i.appuserid !== state.appuserid;
    });
    return (
      <>
        <ul>
          {(() => {
            let messageShown = false;
            return result.map((item, index) => {
              const shouldShowMessage = !finalarray?.[index] && !messageShown;
              if (shouldShowMessage) messageShown = true;

              return (
                <React.Fragment key={index}>
                  {shouldShowMessage && (
                    <li>
                      <div className="text-center m-3 custom-text-primary-md-bold">
                        {LocaleStrings.kAddAssociateuserDesc.replaceAll(
                          "###COMPANY###",
                          state?.companyname
                        )}
                      </div>
                    </li>
                  )}
                  <li>
                    <AssociateUser
                      index={index}
                      data={item}
                      form={`associateuser_${index}`}
                      formArray={state.formArray}
                      state={state}
                      appuserdata={finalarray?.[index] ?? []}
                      handleassociateuser={handleassociateuser}
                    />
                  </li>
                </React.Fragment>
              );
            });
          })()}
        </ul>
      </>
    );
  };

  let isSocialEnabled = false;
  if (eventSettingsData?.data) {
    const custom_settings = JSON.parse(eventSettingsData?.data.custom_settings);
    isSocialEnabled =
      custom_settings?.socialboost_setting?.boostenabled ?? false;
  }

  return (
    <div className="content-body bg-[#F9FAFB] lg:p-16">
      {eventSettingsData?.data ? (
        <>
          <div ref={alertRef}>
            <div className="flex flex-col justify-center items-center space-y-3 mb-12 THANK_YOU_SECTION">
              <img
                src={brokenCircle}
                alt="Tick icon"
                className="BROKEN_CIRCLE"
              />
              <div className="text-2xl font-semibold THANK_YOU_TEXT">
                {LocaleStrings.kThankYouSuccessText}
              </div>
              <div
                className="text-base font-normal break-words text-center THANK_YOU_DESCRIPTION"
                dangerouslySetInnerHTML={{
                  __html: eventSettingsData?.data?.congratulations,
                }}
              ></div>
            </div>
            {isSocialEnabled ? (
              <SocialShare calledFrom="registration" locationState={state} />
            ) : (
              ""
            )}

            <div className="flex justify-end ADD_TO_CALENDAR_SECTION">
              <a
                className="cursor-pointer custom-text-theme-md-medium hover:underline ADD_TO_CALENDAR_BUTTON"
                onClick={() =>
                  confirmAlert({
                    customUI: () => {
                      return (
                        <div>
                          <AddToCalendarButton
                            name={eventData.eventname}
                            options={[
                              "Apple",
                              "Google",
                              "Outlook.com",
                              "Yahoo",
                              "iCal",
                            ]}
                            location={eventData.country}
                            startDate={eventData.eventstartdate}
                            endDate={eventData.eventenddate}
                            startTime="00:00"
                            endTime="23:59"
                            label={LocaleStrings.kSaveToCalendar}
                            buttonsList
                            buttonStyle="round"
                            lightMode="bodyScheme"
                          />
                        </div>
                      );
                    },
                  })
                }
              >
                {LocaleStrings.kSaveToCalendar}
              </a>
            </div>

            {/* divider */}
            <div className="relative py-6 THANK_YOU_PAGE_DIVIDER">
              <div
                className="absolute inset-0 flex items-center"
                aria-hidden="true"
              >
                <div className="w-full border-t border-gray-300" />
              </div>
            </div>
            {/* divider */}
          </div>

          <div
            className={`border border-default shadow-md rounded-md sm:grid sm:grid-cols-3 overflow-hidden ASSIGN_TICKETS_INFO`}
            style={hideAssignDetails ? { display: "none" } : {}}
          >
            {/* User QR */}
            {state?.qrtoken ? (
              <div className="flex items-center justify-center bg-default sm:col-span-1 px-4 py-4 QR_CODE ASSIGN_TICKETS_QR_CODE">
                <div className="p-4 overflow-hidden border border-default rounded-lg w-60 sm:w-full h-full bg-white">
                  <QRCode
                    size={215}
                    style={{ width: "100%", height: "100%" }}
                    viewBox={`0 0 256 256`}
                    value={state?.qrtoken ?? ""}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            {/* Other info */}
            <div
              className={`bg-white ${
                state?.qrtoken ? "sm:col-span-2" : "sm:col-span-3"
              } px-4 py-4 ASSIGN_TICKETS_OTHER_INFO`}
            >
              <section aria-labelledby="information-heading">
                <div className="text-primary text-2xl font-bold ASSIGN_TICKETS_EVENT_NAME break-words">
                  {eventData?.eventname}
                </div>

                {/* divider */}
                <div className="relative py-5 ASSIGN_TICKETS_OTHER_INFO_DIVIDER">
                  <div
                    className="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div className="w-full border-t border-gray-300" />
                  </div>
                </div>
                {/* divider */}

                <div className="space-y-2 md:space-y-0 md:grid md:grid-cols-8 md:space-x-2 mb-3 ASSIGN_TICKETS_USER_INFO">
                  <div className="col-span-3 ASSIGN_TICKETS_ASSIGNED_USERNAME">
                    <div className="custom-text-primary-md-medium">
                      {LocaleStrings.kAttendeeNameText}
                    </div>
                    <div className="custom-text-secondary-md-medium break-words">
                      {state?.firstname ?? "-"} {state?.lastname}
                    </div>
                  </div>
                  <div className="col-span-3 ASSIGN_TICKETS_ASSIGNED_EMAIL">
                    <div className="custom-text-primary-md-medium">
                      {LocaleStrings.kEmail}
                    </div>
                    <div className="custom-text-secondary-md-medium break-all">
                      {state?.email ?? "-"}
                    </div>
                  </div>
                  <div className="col-span-2 ASSIGN_TICKETS_ASSIGNED_PASSCODE">
                    <div className="custom-text-primary-md-medium">
                      {LocaleStrings.kLabelPasscode}
                    </div>
                    <div className="custom-text-secondary-md-medium break-all">
                      {state?.passcode ? (
                        <div
                          className={classNames(
                            displayPasscode ? "space-x-2.5-" : "space-x-4-",
                            "custom-item-vcenter relative"
                          )}
                        >
                          {displayPasscode ? (
                            <span>{state?.passcode}</span>
                          ) : (
                            <span className="">******</span>
                          )}

                          {displayPasscode ? (
                            <EyeIcon
                              className="w-5 h-5 cursor-pointer absolute left-16"
                              onClick={() => handlePasscodeDisplay("hide")}
                            />
                          ) : (
                            <EyeSlashIcon
                              className="w-5 h-5 cursor-pointer absolute left-16"
                              onClick={() => handlePasscodeDisplay("display")}
                            />
                          )}
                        </div>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between py-5 border-t gap-2 mt-6 app-login-button-section APP_LOGIN_BUTTON_SECTION">
                  <div className="space-y-2 md:space-y-0 md:grid md:grid-cols-2 app-stores-buttons APP_STORE_BUTTONS">
                    <img
                      className="col-span-1 cursor-pointer APPSTORE_IMAGE"
                      src={AppStore}
                      alt="AppStore"
                      onClick={() => handleApp("ios")}
                    />
                    <img
                      className="col-span-1 cursor-pointer PLAYSTORE_IMAGE"
                      src={GooglePlay}
                      alt="GooglePlay"
                      onClick={() => handleApp("android")}
                    />
                  </div>

                  <div className="web-login-buttons WEB_LOGIN_BUTTONS">
                    <button
                      className="theme-button-md LOGIN_BUTTON"
                      onClick={openWebPortel}
                    >
                      {LocaleStrings.kLoginPortalText}
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
          {state?.createcompany && (
            <div className="overflow-hidden rounded-md border border-default ASSIGN_TICKETS_LISTS">
              <ul className="divide-y divide-gray-300 mt-3">
                {renderAssociateUser()}
              </ul>
            </div>
          )}

          <div className="text-[#667085] mt-8 text-base SUPPORT_EMAIL">
            {LocaleStrings.ksupportText.replace(
              "###SUPPORTMAIL###",
              eventSettingsData?.data?.supportemail
            )}
          </div>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventData: state.eventData,
    eventSettingsData: state.eventSettingsData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchAssociatedAttendee }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);
